module.exports = __webpack_public_path__ + "img/attach-file.be84bf3a.svg";